export default "__VITE_ASSET__B$UOpsy7__"